import { SubscriptionPlan } from "apiEndPoints";
import APIrequest from "services/axios";
import { logger } from "utils";

export const SubscriptionServices = {
  checkoutPaymentService: async (bodyData) => {
    try {
      const payload = {
        ...SubscriptionPlan.checkoutSubscription,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  createSubscriptionService: async (bodyData) => {
    try {
      const payload = {
        ...SubscriptionPlan.createSubscription,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getSubscriptionService: async () => {
    try {
      const payload = {
        ...SubscriptionPlan.subscriptionDetails,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  getSubscriptionOverviewService: async ({ queryParams }) => {
    try {
      const payload = {
        ...SubscriptionPlan.getSubscriptionOverview,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
